import { useEffect, useState } from 'react'

export interface SupplierUser {
  id: string
  phone: string
  businessName?: string
  tradeLicense?: string
  signedInAt: number
}

const STORAGE_KEY = 'pair2.supplierAuth'

function load(): SupplierUser | null {
  try {
    const v = sessionStorage.getItem(STORAGE_KEY)
    return v ? JSON.parse(v) : null
  } catch {
    return null
  }
}

function save(user: SupplierUser | null) {
  try {
    if (user) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(user))
    else sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignore
  }
}

export function supplierSignIn(
  phone: string,
  businessName?: string,
): SupplierUser {
  const user: SupplierUser = {
    id: 'sup_' + Math.random().toString(36).slice(2, 8),
    phone,
    businessName,
    signedInAt: Date.now(),
  }
  save(user)
  // Dispatch event so hooks update
  window.dispatchEvent(new Event('supplierAuthChanged'))
  return user
}

export function supplierSignOut() {
  save(null)
  window.dispatchEvent(new Event('supplierAuthChanged'))
}

export function useSupplierAuth() {
  const [user, setUser] = useState<SupplierUser | null>(load())

  useEffect(() => {
    const handle = () => setUser(load())
    window.addEventListener('supplierAuthChanged', handle)
    return () => window.removeEventListener('supplierAuthChanged', handle)
  }, [])

  return {
    user,
    isSignedIn: !!user,
    signIn: supplierSignIn,
    signOut: supplierSignOut,
  }
}
